/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Assistant_Restore_FailedInputs */



/**
* | output |
* | --- |
* | "The checkpoint could not be restored: {message}" |
*
* @param {Assistant_Restore_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_restore_failed = /** @type {((inputs: Assistant_Restore_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Restore_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Le point de contrôle n'a pas pu être restauré : ${i?.message}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Der Prüfpunkt konnte nicht wiederhergestellt werden: ${i?.message}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile ripristinare il checkpoint: ${i?.message}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось восстановить контрольную точку: ${i?.message}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se pudo restaurar el punto de control: ${i?.message}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`检查点无法恢复：${i?.message}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`チェックポイントを復元できませんでした: ${i?.message}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`चेकपॉइंट को पुनर्स्थापित नहीं किया जा सका: ${i?.message}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Não foi possível restaurar o ponto de controle: ${i?.message}`)
	return /** @type {LocalizedString} */ (`The checkpoint could not be restored: ${i?.message}`)
});